"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var Input_1 = require("../Input");
var Select_1 = require("../Select");
var date_1 = require("../../utils/validation/date");
var Components_1 = require("../../utils/Components");
var nodash_1 = require("../../utils/nodash");
var getYear = require("date-fns/get_year");
// TODO: Use the helper in utils/dateFormat if there are multiple locales supported.
//       Commented at for the moment to not include the format logic
//       in the bundle just for german dates
// import { monthLabels } from '../../utils/dateFormat';
var DATE_INPUT_MONTHS = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember'
];
var propTypes = {
    id: PropTypes.string,
    value: PropTypes.shape({
        day: PropTypes.string,
        month: PropTypes.string,
        year: PropTypes.string
    }).isRequired,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    variant: PropTypes.oneOf(['monthSelect', 'monthInput']),
    disabled: PropTypes.bool,
    readOnly: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
            day: PropTypes.bool,
            month: PropTypes.bool,
            year: PropTypes.bool
        })
    ]),
    limitMaxlength: PropTypes.bool
};
function getDateErrorsHelper(value, minDate, maxDate) {
    return date_1.getDateErrors(value, { minDate: minDate, maxDate: maxDate });
}
/**
 * The `DateInput` component is a compound component to make to it possible
 * to enter a date more comfortably.
 *
 * In contrast to the `DatePicker` component no visual calendar is shown here.
 * Instead, the user can enter day, month and year into simple text input fields.
 *
 * <div>
 *   <p class="box box--ux">
 *     This component is most suitable for dates which are already known to the user,
 *     e.g. a birthdate or an aniversary. For input scenarios in which the user can
 *     pick between multiple equivalent options, e.g. flight dates, the
 *     <a href="#!/DatePicker">DatePicker component</a> may be a more sensible choice.
 *   </p>
 * </div>
 */
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The component contains three separate fields, but should appear as a single one.
         * Because of this the events of all three components need to be collected and passed to the callback function
         * when it makes sense. Herefore we need to check whether the related target is within the component or not.
         * When the related target is within the component, we don't need to trigger the onBlur callback.
         */
        _this.handleBlur = function (e) {
            var _a = _this.props, onBlur = _a.onBlur, value = _a.value;
            Components_1.handleBlurOutside(e, _this.containerElement, onBlur, value);
        };
        return _this;
    }
    DateInput.prototype.handleChange = function (key, event) {
        var _a;
        var _b = this.props, value = _b.value, onChange = _b.onChange, minDate = _b.minDate, maxDate = _b.maxDate, limitMaxlength = _b.limitMaxlength;
        // React event bubbeling must be stopped in any case because we call onChange on our own.
        event.stopPropagation();
        var rawValue = event.target
            .value;
        var normalizedStringValue = rawValue === '' ? rawValue : String(Number(rawValue));
        if (limitMaxlength) {
            if (key === 'year') {
                normalizedStringValue = normalizedStringValue.substr(0, 4);
            }
            else {
                normalizedStringValue = normalizedStringValue.substr(0, 2);
            }
        }
        var nextValue = __assign({}, value, (_a = {}, _a[key] = normalizedStringValue, _a));
        var errors = getDateErrorsHelper(nextValue, minDate, maxDate);
        onChange(nextValue, errors);
    };
    DateInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, id = _a.id, value = _a.value, error = _a.error, disabled = _a.disabled, variant = _a.variant, onChange = _a.onChange, minDate = _a.minDate, maxDate = _a.maxDate, onBlur = _a.onBlur, onFocus = _a.onFocus, limitMaxlength = _a.limitMaxlength, other = __rest(_a, ["className", "id", "value", "error", "disabled", "variant", "onChange", "minDate", "maxDate", "onBlur", "onFocus", "limitMaxlength"]);
        var componentClassName = classNames(className, 'ee_date-input');
        var dataComponentId = this.props['data-component-id']
            ? this.props['data-component-id']
            : undefined;
        var readOnly = this.props.readOnly;
        if (typeof readOnly !== 'object') {
            readOnly = {
                day: readOnly,
                month: readOnly,
                year: readOnly
            };
        }
        var isMonthInput = variant === 'monthInput';
        var dayFocusId;
        var monthFocusId;
        var yearFocusId;
        if (id) {
            dayFocusId = id + "-day";
            monthFocusId = id + "-month";
            yearFocusId = id + "-year";
        }
        return (React.createElement("span", __assign({ className: componentClassName, id: id }, other, { ref: function (el) { return (_this.containerElement = el); } }),
            React.createElement("span", { className: classNames('ee_date-input__control', 'ee_date-input__control--day') },
                React.createElement(Input_1.Input, { error: error, onChange: function (e) {
                        return _this.handleChange('day', e);
                    }, onFocus: onFocus, onBlur: this.handleBlur, "data-component-id": dataComponentId ? dataComponentId + "-day" : undefined, value: value.day || '', type: "number", min: "1", max: "31", placeholder: isMonthInput ? 'TT' : 'Tag', "aria-label": "Tag", disabled: disabled, readOnly: readOnly.day, className: "ee_date-input__input", "data-focus-id": dayFocusId })),
            React.createElement("span", { className: classNames('ee_date-input__control', 'ee_date-input__control--month') }, variant === 'monthSelect' ? (React.createElement(Select_1.Select, { error: error, className: classNames({
                    'ee_date-input__select--disabled': readOnly.month
                }), onChange: function (e) {
                    return _this.handleChange('month', e);
                }, onFocus: this.props.onFocus, onBlur: this.handleBlur, "data-component-id": dataComponentId ? dataComponentId + "-month" : undefined, value: value.month, "aria-label": "Monat", disabled: disabled, readOnly: readOnly.month, "data-focus-id": monthFocusId },
                React.createElement("option", { value: "", disabled: readOnly.month }, "Monat"),
                DATE_INPUT_MONTHS.map(function (k, i) { return (React.createElement("option", { disabled: readOnly.month &&
                        (i + 1).toString() !== value.month, key: i, value: i + 1 }, k)); }))) : (React.createElement(Input_1.Input, { error: error, onChange: function (e) {
                    return _this.handleChange('month', e);
                }, onFocus: this.props.onFocus, onBlur: this.handleBlur, "data-component-id": dataComponentId ? dataComponentId + "-month" : undefined, value: value.month || '', type: "number", min: "1", max: "12", placeholder: isMonthInput ? 'MM' : 'Monat', "aria-label": "Monat", disabled: disabled, readOnly: readOnly.month, className: "ee_date-input__input", "data-focus-id": monthFocusId }))),
            React.createElement("span", { className: classNames('ee_date-input__control', 'ee_date-input__control--year') },
                React.createElement(Input_1.Input, { error: error, onChange: function (e) {
                        return _this.handleChange('year', e);
                    }, onFocus: this.props.onFocus, onBlur: this.handleBlur, "data-component-id": dataComponentId ? dataComponentId + "-year" : undefined, value: value.year || '', type: "number", min: minDate ? getYear(minDate) : undefined, max: maxDate ? getYear(maxDate) : undefined, placeholder: isMonthInput ? 'JJJJ' : 'Jahr', "aria-label": "Jahr", disabled: disabled, readOnly: readOnly.year, className: "ee_date-input__input", "data-focus-id": yearFocusId }))));
    };
    DateInput.propTypes = propTypes;
    DateInput.defaultProps = {
        id: undefined,
        onChange: nodash_1.noop,
        onBlur: nodash_1.noop,
        value: {},
        error: undefined,
        minDate: undefined,
        maxDate: undefined,
        variant: 'monthInput',
        disabled: false,
        readOnly: false,
        limitMaxlength: true
    };
    DateInput.isCompoundControl = true;
    return DateInput;
}(react_1.Component));
exports.DateInput = DateInput;
exports.default = DateInput;
//# sourceMappingURL=DateInput.js.map
